import axios from "axios";
import { getCookie } from "cookies-next";
import { TOKEN } from "./localStorage";

// initialize axios
export const api = axios.create({
  baseURL: `https://api.mubarakmarinegroup.ae/api`,
  headers: {
    "Content-type": "application/json",
  },
});
